import React,{Component} from "react";
import './assets/bootstrap/css/bootstrap.min.css'
import './assets/bootstrap/css/bootstrap-grid.min.css'
import './assets/bootstrap/css/bootstrap-reboot.min.css'
import './assets/images/background4.jpg'
import  './assets/mobirise/css/mbr-additional.css'
//import './assets/bootstrap/js/bootstrap.min'
import './assets/dropdown/css/style.css'
//import './assets/dropdown/js'
//import './assets/formoid/formoid.min'
import './assets/images/background4.jpg'
import './assets/images/kisspng-blockchain-vector-graphics-computer-icons-illustra-flvr-calculator-chasing-coins-5bf69839402611.9278574715428874812628-192x192.png'
import './assets/images/kisspng-blockchain-vector-graphics-computer-icons-illustra-flvr-calculator-chasing-coins-5bf69839402611.9278574715428874812628-220x220.png'
import './assets/mobirise/css/mbr-additional.css'
//import './assets/parallax/jarallax.min'
//import './assets/popper/popper.min'
//import './assets/smoothscroll/smooth-scroll'
import './assets/socicon/css/styles.css'
import './assets/socicon/fonts/socicon.eot'
import './assets/socicon/fonts/socicon.svg'
import './assets/socicon/fonts/socicon.ttf'
import './assets/socicon/fonts/socicon.woff'
// import './assets/socicon/fonts/socicon.woff2'
import './assets/tether/tether.min.css'
//import './assets/tether/tether.min'
import './assets/theme/css/style.css'
//import './assets/theme/js/script'
//import './assets/touchswipe/jquery.touch-swipe.min'
//import './assets/web/assets/jquery/jquery.min'
import './assets/web/assets/mobirise-icons/mobirise-icons.css'
import './assets/web/assets/mobirise-icons/mobirise-icons.eot'
import './assets/web/assets/mobirise-icons/mobirise-icons.svg'
import './assets/web/assets/mobirise-icons/mobirise-icons.ttf'
import './assets/web/assets/mobirise-icons/mobirise-icons.woff'
import {Link} from 'react-router-dom'




class indexx extends Component{
render() {

    return(
<div>




    <section className="menu cid-qTkzRZLJNu" nonce="menu" id="menu1-0">


        <nav
            className="navbar navbar-expand beta-menu navbar-dropdown align-items-center navbar-fixed-top navbar-toggleable-sm">
            <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">
                <div className="hamburger">

                </div>
            </button>
            <div className="menu-logo">
                <div className="navbar-brand">
                <span className="navbar-logo">
                    <a href="#">
                         <img src="./assets/images/kisspng-blockchain-vector-graphics-computer-icons-illustra-flvr-calculator-chasing-coins-5bf69839402611.9278574715428874812628-220x220.png"
                             alt="KeyBlockInc" title="" style={{height: '3.8rem'}} />
                    </a>
                </span>
                    <span className="navbar-caption-wrap"><a className="navbar-caption text-white display-7"
                                                             href="">KeyBlock<br/></a></span>
                </div>
            </div>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav nav-dropdown" data-app-modern-menu="true">
                    <li className="nav-item">
                        <a className="nav-link link text-white display-7" >
                            <span className=""/>
                            <span className="mbri-home mbr-iconfont mbr-iconfont-btn"/>
                            Services
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link link text-white display-7" >
                            <span className="mbri-search mbr-iconfont mbr-iconfont-btn"/>
                            About Us
                        </a>
                    </li>
                </ul>
                <div className="navbar-buttons mbr-section-btn">
                    <a className="btn btn-sm btn-success display-4">
                        <span className="mbri-sites mbr-iconfont mbr-iconfont-btn"/>
                    Try It Now!
                </a></div>
            </div>
        </nav>
    </section>

    <section className="engine"><a href="https://mobirise.info/n">simple website templates</a></section>
    <section className="cid-qTkA127IK8 mbr-fullscreen mbr-parallax-background" id="header2-1">


        <div className="container align-center">
            <div className="row justify-content-md-center">
                <div className="mbr-white col-md-10">
                    <h1 className="mbr-section-title mbr-bold pb-3 mbr-fonts-style display-1">KeySecure</h1>

                    <p className="mbr-text pb-3 mbr-fonts-style display-5">
                        Our Secure Block-Chain decentralized application technology<br/> makes your online and offline
                        identity authentication easier and reliable.</p>
                    <div className="mbr-section-btn"><Link className="btn btn-md btn-primary display-4"
                                                        to={"/login"}>Login</Link>

                        <Link className="btn btn-md btn-white text-dark display-4" to={'/SignUp'}>Get
                            Account<br/></Link></div>
                </div>
            </div>
        </div>
    </section>

    <section className="cid-qTkAaeaxX5" id="footer1-2">


        <div className="container">
            <div className="media-container-row content text-white">
                <div className="col-12 col-md-3">
                    <div className="media-wrap">
                        <a href="#">
                            <img
                                src="assets/images/kisspng-blockchain-vector-graphics-computer-icons-illustra-flvr-calculator-chasing-coins-5bf69839402611.9278574715428874812628-192x192.png"
                                alt="Mobirise" title=""/>
                        </a>
                    </div>
                </div>
                <div className="col-12 col-md-3 mbr-fonts-style display-7">
                    <h5 className="pb-3">
                        Address
                    </h5>
                    <p className="mbr-text">
                        1234 Street Name
                        <br/>City, AA 99999
                    </p>
                </div>
                <div className="col-12 col-md-3 mbr-fonts-style display-7">
                    <h5 className="pb-3">
                        Contacts
                    </h5>
                    <p className="mbr-text">
                        Email: support@mobirise.com
                        <br/>Phone: +1 (0) 000 0000 001
                            <br/>Fax: +1 (0) 000 0000 002
                    </p>
                </div>
                <div className="col-12 col-md-3 mbr-fonts-style display-7">
                    <h5 className="pb-3">
                        Links
                    </h5>
                    <p className="mbr-text">Ethereum.org<br/>Solidity<br/>Truffle</p>
                </div>
            </div>
            <div className="footer-lower">
                <div className="media-container-row">
                    <div className="col-sm-12">
                        <hr/>
                    </div>
                </div>
                <div className="media-container-row mbr-white">
                    <div className="col-sm-6 copyright">
                        <p className="mbr-text mbr-fonts-style display-7">
                            © Copyright - All Rights Reserved
                        </p>
                    </div>
                    <div className="col-md-6">
                        <div className="social-list align-right">
                            <div className="soc-item">
                                <a  target="_blank">
                                    <span className="socicon-twitter socicon mbr-iconfont mbr-iconfont-social"/>
                                </a>
                            </div>
                            <div className="soc-item">
                                <a target="_blank">
                                    <span className="socicon-facebook socicon mbr-iconfont mbr-iconfont-social"/>
                                </a>
                            </div>
                            <div className="soc-item">
                                <a  target="_blank">
                                    <span className="socicon-youtube socicon mbr-iconfont mbr-iconfont-social"/>
                                </a>
                            </div>
                            <div className="soc-item">
                                <a  target="_blank">
                                    <span className="socicon-instagram socicon mbr-iconfont mbr-iconfont-social"/>
                                </a>
                            </div>
                            <div className="soc-item">
                                <a  target="_blank">
                                    <span
    className="socicon-googleplus socicon mbr-iconfont mbr-iconfont-social"/>
                                </a>
                            </div>
                            <div className="soc-item">
                                <a target="_blank">
                                    <span className="socicon-behance socicon mbr-iconfont mbr-iconfont-social"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <script src="assets/web/assets/jquery/jquery.min.js"/>
    <script src="assets/popper/popper.min.js"/>
    <script src="assets/bootstrap/js/bootstrap.min.js"/>
    <script src="assets/tether/tether.min.js"/>
    <script src="assets/dropdown/js/nav-dropdown.js"/>
    <script src="assets/dropdown/js/navbar-dropdown.js"/>
    <script src="assets/touchswipe/jquery.touch-swipe.min.js"/>
    <script src="assets/parallax/jarallax.min.js"/>
    <script src="assets/smoothscroll/smooth-scroll.js"/>
    <script src="assets/theme/js/script.js"/>



</div>

    )
}
}
export default indexx;